import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef, HostListener, HostBinding } from '@angular/core';
import { RuleId } from '../../models/rule-id';
import { FilterNavigationBase } from '../filter-navigation-base';

@Component({
  selector: '[filter-title]',
  template: `
<span class="filter-title-text">{{ text }}</span>
<div class="filter-tip" [class.pinned]="pinned" (click)="pinned = !pinned"><p (click)="$event.stopPropagation()"><ng-content></ng-content></p></div>
<ng-template [ngTemplateOutlet]="additionalContent"></ng-template>
@if (activeRules !== undefined) {
  <span class="active-filters">{{ activeRules }} active rule{{ activeRules === 1 ? '' : 's' }}</span>
}
  `,
  styles: `
.filter-tip::before {
  pointer-events: none;
}

.filter-tip {
  cursor: pointer;
}

.filter-tip:has(p:empty) {
  display: none;
}

.filter-tip.pinned {
  p {
    display: block !important;
    cursor: default;
  }
}

.filter-tip.pinned::before {
  content: "(x)";
}

.active-filters {
  float: right;
  color: #afa89fbd !important;
}

@media (hover: none) and (pointer: coarse) {
  ::ng-deep .filter-title .filter-tip:hover p {
    display: none !important;
  }
}
  `,
  host: { 'class': 'filter-title' },
  imports: [NgTemplateOutlet]
})
export class FilterTitleComponent extends FilterNavigationBase {
  @Input() text: string = '';
  @Input() additionalContent: TemplateRef<any> | null = null;
  @Input() activeRules?: number;
  @Input() declare ruleId?: RuleId;
  @Input() declare ruleIds?: RuleId[];
  @Input() declare prefixMatch?: boolean;
  pinned: boolean = false;

  constructor() {
    super();
  }
}
